export const promptCategory = [
	{
		name: 'Lead',
		description:
			'Dive into lead management with insights on lead stages and attribution.',
		type: 5,
	},
	{
		name: 'Opportunity',
		description:
			'Explore revenue, pipeline insights, and associated marketing channels for your opportunities.',
		type: 4,
	},
	{
		name: 'Sales Cycle',
		description:
			'Discover transition times across lead and current pipeline across opportunity stages.',
		type: 3,
	},
	{
		name: 'Web Analytics',
		description:
			"Access behavioral data for users who've visited your website.",
		type: 2,
	},
	{
		name: 'PPC Advertising',
		description:
			'Dive into performance marketing with a consolidated view of your paid ad campaigns.',
		type: 1,
	},
];

export function generateUniqueId() {
    // Generate a random number and convert it to a string
    const randomPart = Math.random()?.toString(36)?.substr(2, 9);

    // Get the current timestamp and convert it to a string
    const timestampPart = (new Date()?.getTime()?.toString(36));

    // Combine the timestamp and random parts
    const uniqueId = timestampPart + randomPart;

    return uniqueId;
}

export enum ChatBotResponseType {
	DATA_TABLE_AND_BAR_GRAPH_RESPONSE = 1,
	INTEGER_TYPE_RESPONSE = 2,
	STRING_RESPONSE = 3,
	BARGRAPH_RESPONSE = 4,
}

export enum GraphType {
	// BAR_CHART = 1,
	STACKED_GRAPH_CHART = 2,
	BAR_CHART = 3,
	PIE_CHART = 4,
	HORIZONTAL = 5,
	DONUT_GRAPH = 6,
	LINE_GRAPH = 7,
	SCATTER_PLOT = 8,
	LINE_CHART = 9,
	DATA_TABLE = 0,
}

export enum FeedBackType {
	NEGATIVE = 0,
	POSTIVE = 1,
	FAVOURITE = 2,
	UNFAVOURITE = 3,
}
